<template>
  <LoginModal @close="$emit('close')" :title="title">
    <v-dialog />
    <div class="LoginCode-codes">
      <input
        type="number"
        class="LoginCode-code"
        @wheel="$event.target.blur()"
        :maxlength="1"
        v-model="code1"
        ref="code1"
      />
      <input
        type="number"
        class="LoginCode-code"
        @wheel="$event.target.blur()"
        :maxlength="1"
        v-model="code2"
        ref="code2"
      />
      <input
        type="number"
        class="LoginCode-code"
        @wheel="$event.target.blur()"
        :maxlength="1"
        v-model="code3"
        ref="code3"
      />
      <input
        type="number"
        class="LoginCode-code"
        @wheel="$event.target.blur()"
        :maxlength="1"
        v-model="code4"
        ref="code4"
      />
    </div>
    <span class="LoginCode-resend" v-if="showResend" @click="resend">{{
      $t('login.code.resend')
    }}</span>

    <div class="LoginCode-submit">
      <BSCButton
        typeButton="submit"
        :label="$t('login.label.connect')"
        type="primary"
        :disabled="!canSubmit"
        :loading="loading"
        @click.native="submit"
      />
    </div>
  </LoginModal>
</template>

<script>
'use strict'

import { mapGetters } from 'vuex'

import LoginModal from '@/components/login/LoginModal'
import { getRoleByLocalStorage } from '@/utils/function'
import { ACTUAL_ROLE } from '@/utils/consts'

export default {
  name: 'LoginCode',
  components: { LoginModal },
  data() {
    return {
      code1: '',
      code2: '',
      code3: '',
      code4: '',
      copy: false,
      showResend: false,
      loading: false
    }
  },
  computed: {
    ...mapGetters({
      login_data: 'auth/login_data'
    }),
    title() {
      return this.login_data.method.name
    },
    canSubmit() {
      return !!this.code1 && !!this.code2 && !!this.code3 && !!this.code4
    }
  },
  methods: {
    valideCode() {
      if (
        !!this.code1 &&
        !!this.code2 &&
        !!this.code3 &&
        !!this.code4 &&
        !this.copy
      ) {
        this.sendCode(`${this.code1}${this.code2}${this.code3}${this.code4}`)
      }
    },
    submit() {
      if (!!this.code1 && !!this.code2 && !!this.code3 && !!this.code4) {
        this.sendCode(`${this.code1}${this.code2}${this.code3}${this.code4}`)
      }
    },

    valideCopyCode() {
      if (!!this.code1 && !!this.code2 && !!this.code3 && !!this.code4) {
        this.sendCode(`${this.code1}${this.code2}${this.code3}${this.code4}`)
      }
    },
    sendCode(code) {
      this.loading = true
      this.$store
        .dispatch('auth/valideCode', code)
        .then(r => {
          this.loading = false
          this.$emit('close')
        })
        .catch(e => {
          this.code1 = ''
          this.code2 = ''
          this.code3 = ''
          this.code4 = ''
          this.loading = false
          this.showError()
          // this.$log.fatal(e)
          // this.$emit("close")
        })
    },
    showError() {
      this.$modal.show('dialog', {
        title: 'Erreur',
        text: this.$t('login.label.wrongCode'),
        draggable: false,
        adaptive: true,
        buttons: [
          {
            title: 'ok',
            handler: () => {
              this.$store.dispatch('auth/resetSteep')
              this.$modal.hide('dialog')
            }
          }
        ]
      })
    },
    resend() {
      if (getRoleByLocalStorage() === ACTUAL_ROLE.TRAINER) {
        this.resendReferToRole(ACTUAL_ROLE.TRAINER)
      } else if (getRoleByLocalStorage() === ACTUAL_ROLE.SPONSOR) {
        this.resendReferToRole(ACTUAL_ROLE.SPONSOR)
      }
    },
    /**
     * @param {string} role - User role
     */
    resendReferToRole(role) {
      let trainerResend = 'resendCode'
      let sponsorResend = 'resendCodeSponsor'
      this.$store
        .dispatch(
          `auth/${role === ACTUAL_ROLE.TRAINER ? trainerResend : sponsorResend}`
        )
        .then(() => {
          this.$store.dispatch('utils/addToast', {
            label: 'Code renvoyée',
            type: 'primary'
          })
          this.showResend = false
          setTimeout(() => (this.showResend = true), 15000)
        })
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs.code1.focus()
    })
    setTimeout(() => (this.showResend = true), 15000)
  },
  watch: {
    code1(newValue, oldValue) {
      if (newValue.length === 4) {
        this.copy = true
        this.code1 = newValue.slice(0, 1)
        this.code2 = newValue.slice(1, 2)
        this.code3 = newValue.slice(2, 3)
        this.code4 = newValue.slice(3, 4)
        this.valideCopyCode()
      } else {
        if (0 <= newValue && newValue <= 9 && !!newValue) {
          this.$refs.code2.focus()
          if (!this.copy) this.valideCode()
        } else if (!newValue) {
          this.code1 = ''
        } else {
          this.code1 = oldValue
        }
      }
    },
    code2(newValue, oldValue) {
      if (0 <= newValue && newValue <= 9 && !!newValue) {
        this.$refs.code3.focus()
        if (!this.copy) this.valideCode()
      } else if (!newValue) {
        this.code2 = ''
      } else {
        this.code2 = oldValue
      }
    },
    code3(newValue, oldValue) {
      if (0 <= newValue && newValue <= 9 && !!newValue) {
        this.$refs.code4.focus()
        if (!this.copy) this.valideCode()
      } else if (!newValue) {
        this.code3 = ''
      } else {
        this.code3 = oldValue
      }
    },
    code4(newValue, oldValue) {
      if (0 <= newValue && newValue <= 9 && !!newValue) {
        this.$refs.code1.focus()
        if (!this.copy) this.valideCode()
      } else if (!newValue) {
        this.code4 = ''
      } else {
        this.code4 = oldValue
      }
    },
    error(newValue) {
      if (!newValue) {
        this.code1 = ''
        this.code2 = ''
        this.code3 = ''
        this.code4 = ''
        this.copy = false
      }
    }
  }
}
</script>
<style lang="scss">
.LoginCode {
  cursor: pointer;
  text-align: center;
  font-weight: 500;
  padding: 1.5rem 0;
  transition-duration: 0.5s;

  &-codes {
    display: flex;
    margin-top: 2rem;
  }

  &-submit {
    margin-top: 2rem;
  }

  &-code {
    -webkit-appearance: none;
    margin: 0;
    -moz-appearance: textfield;
    border: none;
    margin: 0 0.2rem;
    width: 40px;
    border-bottom: 2px solid $blue;
    text-align: center;
    font-size: 2rem;
    font-weight: 500;

    &[disabled] {
      background-color: $white;
      color: $text-grey;
    }
  }

  &-resend {
    cursor: pointer;
    margin-top: 1.5rem;
    color: $text-grey;
    text-decoration: underline;

    &:hover {
      text-decoration: none;
    }
  }
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type='number'] {
  -moz-appearance: textfield;
}
</style>
